<template>
  <div class="cal-month-picker">
    <div class="cal-month-picker__row">
      <div class="cal-month-picker__col">
        <label class="cal-month-picker__label">{{ $t('start') || 'From' }}</label>
        <month-picker-input
            ref="startPicker"
            v-model="pickerValue.start"
            editable-year
            :default-month="defaultPickerValue.start.monthIndex"
            :default-year="defaultPickerValue.start.year"
            :lang="deviceBasicLang"
            @input="onStartInput"
        />
      </div>
      <div class="cal-month-picker__col">
        <label class="cal-month-picker__label">{{ $t('to') || 'To' }}</label>
        <month-picker-input
            ref="endPicker"
            v-model="pickerValue.end"
            editable-year
            :min-date="minDateValue"
            :default-month="defaultPickerValue.end.monthIndex"
            :default-year="defaultPickerValue.end.year"
            :lang="deviceBasicLang"
            :active="pickerValue.start != null"
            @input="onEndInput"
            @click-outside="setInputValue"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "monthPickerRange",
  props: {
    value: {
      default: () => ({})
    },
    startKey: {
      default: "start"
    },
    endKey: {
      default: "end"
    }
  },
  data: () => ({
    loadingData: true,
    defaultPickerValue: {
      start: {year: null, monthIndex: null},
      end: {year: null, monthIndex: null}
    },
    pickerValue: {
      start: null,
      end: null
    },
    momentValue: {
      start: null,
      end: null
    },
    stringValue: {
      start: null,
      end: null
    },
    minDateValue: null,
  }),
  watch: {
    value: {
      immediate: false,
      handler(val) {
        console.log("monthPickerRange -> watch value", val);
        this.setPickerValue();
      }
    }
  },
  mounted() {
    console.log("deviceLang", this.deviceBasicLang);
    this.setPickerValue();
  },
  methods: {
    setPickerValue() {
      if (this.value == null) {
        console.log("monthPickerRange -> setPickerValue -> this.value == null");
        this.$emit("input", {[this.startKey]: this.$moment.startOf('month').format('YYYY-MM-DD'), [this.endKey]: this.$moment.endOf('month').format('YYYY-MM-DD')});
        return;
      }
      if (this.value[this.startKey] == null || this.value[this.endKey] == null) {
        console.log("monthPickerRange -> setPickerValue -> this.value[this.startKey] == null || this.value[this.endKey] == null")
        let start = this.value[this.startKey] || this.$moment().startOf('month').format('YYYY-MM-DD');
        let end = this.value[this.endKey] || this.$moment().endOf('month').format('YYYY-MM-DD');
        this.$emit("input", {[this.startKey]: start, [this.endKey]: end});
        return;
      }
      console.log("monthPickerRange -> setPickerValue", this.value);
      this.loadingData = true;
      if (this.value[this.startKey] !== this.stringValue.start) {
        let momentValue = this.$moment(this.value[this.startKey]);
        this.stringValue.start = momentValue.format("YYYY-MM-DD");
        let selection = this.defaultPickerValue.start = {year: momentValue.year(), monthIndex: momentValue.month()};
        this.$refs.startPicker.getMonthPicker().selectMonth(selection.monthIndex, false);
        this.$refs.startPicker.getMonthPicker().year = selection.year;
      }
      if (this.value[this.endKey] !== this.stringValue.end) {
        let momentValue = this.$moment(this.value[this.endKey]);
        this.stringValue.end = momentValue.format("YYYY-MM-DD");
        let selection = this.defaultPickerValue.start = {year: momentValue.year(), monthIndex: momentValue.month()};
        this.$refs.endPicker.getMonthPicker().selectMonth(selection.monthIndex, false);
        this.$refs.endPicker.getMonthPicker().year = selection.year;
        // this.$refs.endPicker.getMonthPicker().changeYear(selection.year);
      }
      this.loadingData = false;
    },
    onStartInput(value) {
      console.log("onStartInput", value);
      this.momentValue.start = this.$moment("" + value.year + "" + value.monthIndex, "YYYY-MM");
      this.stringValue.start = this.momentValue.start.format("YYYY-MM-DD");
      if(this.momentValue.end != null && this.momentValue.end.isBefore(this.momentValue.start)) {
        this.momentValue.end = this.momentValue.start.clone().endOf('month');
        this.stringValue.end = this.momentValue.end.format("YYYY-MM-DD");
        this.defaultPickerValue.end.monthIndex = this.momentValue.end.month();
        this.$refs.endPicker.getMonthPicker().selectMonth(this.defaultPickerValue.end.monthIndex, false);
        this.$refs.endPicker.getMonthPicker().year = this.momentValue.end.year();
      }
      this.minDateValue = this.momentValue.start.clone().startOf('month').toDate();
      let $this = this;
      setTimeout(() => {
        $this.$refs.endPicker.showMonthPicker();
      }, 100);

      // this.setInputValue();
    },
    onEndInput(value) {
      console.log("onEndInput", value);
      this.momentValue.end = this.$moment("" + value.year + "" + value.monthIndex, "YYYY-MM").endOf('month');
      this.stringValue.end = this.momentValue.end.format("YYYY-MM-DD");
      this.setInputValue();
    },
    setInputValue() {
      if (this.loadingData) {
        return;
      }
      let input = {[this.startKey]: this.stringValue.start, [this.endKey]: this.stringValue.end};
      console.log("setInputValue", input);
      this.$emit("input", input);
    }
  },
}
</script>

<style lang="scss" scoped>
.cal-month-picker__row { display: flex; gap: 14px; flex-wrap: wrap; }
.cal-month-picker__col { flex: 1; min-width: 140px; }
.cal-month-picker__label {
  display: block; font-size: .7rem; font-weight: 700; text-transform: uppercase; letter-spacing: .04em;
  color: #64748b; margin-bottom: 4px;
}
.cal-month-picker :deep(.month-picker-input-container) { width: 100%; }
.cal-month-picker :deep(.month-picker-input-container input) {
  width: 100%; padding: 8px 12px; border: 1px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; font-size: .875rem; color: #1e293b;
  transition: border-color .2s, box-shadow .2s;
}
.cal-month-picker :deep(.month-picker-input-container input:hover) { border-color: #cbd5e1; }
.cal-month-picker :deep(.month-picker-input-container input:focus) {
  outline: none; border-color: #059669; box-shadow: 0 0 0 3px rgba(5, 150, 105, .15);
}
.cal-month-picker :deep(.month-picker__container) { left: 0; top: 100%; margin-top: 6px; z-index: 1050; }
</style>
<style lang="scss">
.dark-layout .cal-month-picker .cal-month-picker__label { color: #94a3b8; }
.dark-layout .cal-month-picker .month-picker-input-container input {
  background: #1e2a3e !important; border-color: rgba(255,255,255,.1) !important; color: #e2e8f0 !important;
}
.dark-layout .cal-month-picker .month-picker-input-container input:focus {
  border-color: #059669 !important; box-shadow: 0 0 0 3px rgba(5, 150, 105, .2) !important;
}
.cal-date-popover .cal-month-picker .month-picker__container { left: -200px; }
</style>
